import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tab from "../../../components/Tabs/";
import Empty from "../../../components/Empty";
import NoAccess from "../../../components/NoAccess";
import IntlService from "../components/Service";
import IntlAddModal from "../components/AddModal";
import IntlTable from "../components/IntlTable";
import { message } from "../../../components/Message";
import errorCode from "../../../utils/errCode";
import { useWorkspace } from "../../../context/WorkspaceRegionProvider";
import { buildIntlCreatePayload } from "../../../utils/intlSoft";
import {
  createIntlSoft,
  fetchIntlSoftLists,
} from "../hooks/useIntlSoftApi";
import homeStyles from "../../home/index.modules.less";

const IntlSoftList = ({ data, loading, tabkey, setOpen }) => {
  const list = data?.list ?? [];
  if (!loading && list.length === 0) {
    return <Empty setOpen={setOpen} />;
  }
  return <IntlTable tabkey={tabkey} data={data} />;
};

const IntlHome = () => {
  const [showListType] = useState("table");
  const { user, permission } = useSelector((state) => state);
  const { canUseIntl } = useWorkspace();
  const dispatch = useDispatch();
  const modelRef = React.useRef(null);

  const [softList, setSoftList] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [createPending, setCreatePending] = useState(false);
  const [tabkey, setTabkey] = useState(911);

  const loadLists = useCallback(async () => {
    if (!canUseIntl) {
      return null;
    }
    setLoading(true);
    try {
      const data = await fetchIntlSoftLists({ p_num: 1, p_size: 200 });
      setSoftList(data || {});
      return data;
    } catch (error) {
      message.show({
        type: "error",
        content: errorCode[error?.errno] || error?.errmsg || "国际软件列表加载失败",
      });
      return null;
    } finally {
      setLoading(false);
    }
  }, [canUseIntl]);

  useEffect(() => {
    if (user?.is_mfr == false) {
      modelRef?.current?.show();
    }
    if (user?.qid && canUseIntl) {
      dispatch.config.setConfigAsync();
      loadLists();
    }
  }, [user, canUseIntl, dispatch.config, loadLists]);

  const onCreate = async (values) => {
    if (!canUseIntl) {
      message.show({ type: "error", content: "当前企业未开通国际分发能力" });
      return;
    }

    const payload = buildIntlCreatePayload(values);

    setCreatePending(true);
    try {
      await createIntlSoft(payload);
      await loadLists();
      message.show({ type: "success", content: "软件创建成功" });
      setOpen(false);
    } catch (error) {
      message.show({
        type: "error",
        content: errorCode[error?.errno] || error?.errmsg || "创建失败",
      });
    } finally {
      setCreatePending(false);
    }
  };

  const tabs = [
    {
      id: 911,
      name: "我的全部软件",
      component: (
        <IntlSoftList
          loading={loading}
          data={softList}
          tabkey={tabkey}
          setOpen={setOpen}
        />
      ),
    },
    {
      id: 4,
      name: "已上架",
      component: (
        <IntlSoftList
          loading={loading}
          data={softList}
          tabkey={tabkey}
          setOpen={setOpen}
        />
      ),
    },
    {
      id: 2,
      name: "申请中",
      component: (
        <IntlSoftList
          loading={loading}
          data={softList}
          tabkey={tabkey}
          setOpen={setOpen}
        />
      ),
    },
  ];

  if (!user?.is_mfr && !permission?.isUnionUser) {
    return <NoAccess ref={modelRef} />;
  }

  return (
    <div className={homeStyles.homeWrapper}>
      <IntlService
        setOpen={setOpen}
        identityType={permission?.identityType}
        permissionCodes={permission?.permissionCodes}
      />
      <Tab
        defaultActiveKey={911}
        onChangeTab={(key) => setTabkey(key)}
        onChangeShowType={() => { }}
        showListType={showListType}
        items={tabs.map((item) => ({
          label: item.name,
          key: item.id,
          children: item.component,
        }))}
      />
      <NoAccess ref={modelRef} />
      <IntlAddModal
        open={open}
        onCreate={onCreate}
        onCancel={() => setOpen(false)}
        confirmLoading={createPending}
      />
      <div className={homeStyles.footer}>
        <span>
          Copyright © 2005 - <span className="current-year">2026</span> 360.CN All Rights Reserved 360互联网安全中心隐私权政策 京ICP证080047号
        </span>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502062738" rel="noreferrer" target="_blank" ><img src="//p4.ssl.qhmsg.com/t01d8eda6e551cf2615.png" alt="" />京公网安备11010502062738号</a>
      </div>
    </div>
  );
};

export default IntlHome;
